import script from "./MM.vue?vue&type=script&lang=js"
export * from "./MM.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__